<template>
  <div>
    <v-card>
      <v-card-title class="page-heading"> Appointment Options </v-card-title>
      <v-card-actions class="centerContainer">
        <v-btn
          class="justify-center"
          color="primary"
          height="45px"
          :disabled="existingAppointment && !isNewServiceType"
          block
          @click="newAppointmentClick()"
          >NEW APPOINTMENT
        </v-btn>
      </v-card-actions>
      <v-card-text
        >Use this option to schedule a new appointment. For each card you hold, you may have one
        active appointment scheduled for each service.</v-card-text
      >
      <v-card-actions class="centerContainer">
        <v-btn
          class="justify-center"
          color="primary"
          height="45px"
          :disabled="!existingAppointment"
          block
          @click="nextPage('ViewExistingPage')"
          >EXISTING APPOINTMENT
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <p>Use this option to:</p>
        <div class="font-weight-bold">View Appointment</div>
        <div>View the date, time and location of your existing appointment.</div>
        <div class="font-weight-bold">Cancel an Existing Appointment</div>
        <div>
          If you cancel your appointment, there may be a delay in the availability of a new
          appointment.
        </div>
        <div class="font-weight-bold">Reschedule an Existing Appointment</div>
        <div>You may have only one active appointment scheduled for each service.</div>
      </v-card-text>
      <v-card-actions class="centerContainer">
        <v-col rows="12" md="2">
          <v-btn class="justify-center" color="primary" @click="previousClick()"
          ><v-icon>mdi-arrow-left</v-icon>
          PREVIOUS
        </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
    <!-- <pre>Phoenix response: {{ eligibilityData }}</pre> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LandingPage',
  props: {
    eligibilityData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions(['isLogIn']),
    ...mapActions('bookingDetails', {
      newAppointmentSelectedAction: 'newAppointmentSelected',
    }),
    nextPage(page) {
      this.$emit('navigateTo', page, this.eligibilityData);
    },
    previousClick() {
      this.isLogIn({ value: false });
      this.$emit('navigateTo', 'LoginPage');
    },
    newAppointmentClick() {
      if (this.isNewServiceType) {
        this.newAppointmentSelectedAction({ value: true });
      }
      this.$emit('navigateTo', 'CustomerDetailsPage');
    },
  },
  computed: {
    ...mapGetters(['existingAppointment', 'isNewServiceType']),
  },
};
</script>
